import { createRoutes as createDealerRoutes } from './dealer/router'
import { createRoutes as createSellerRoutes } from './seller/router'

export function createRoutes() {
  return [
    ...createDealerRoutes(),
    ...createSellerRoutes(),
  ]
}
